<div
  class="icon-wrapper"
  [ngStyle]="{
    'width': bgSize || iconSize,
    'height': bgSize || iconSize,
    'transform': transform,
  }">
  <svg
    viewBox="0 0 24 24"
    class="d-flex"
    [style.width]="iconSize"
    [style.height]="iconSize"
    [style.fill]="color"
    [style.animation]="animate"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g *ngIf="svgIcon" [innerHTML]="svgIcon">
      <ng-content></ng-content>
    </g>
  </svg>

  <span
    *ngIf="background"
    #backgroundElRef
    [style.width]="bgSize"
    [style.height]="bgSize"
  ></span>
</div>